export type IEmployee = {
  _id?: string;
  name: string;
  email: string;
  companyId: string;
  companyIds?: string[];
  type: TYPE_EMPLOYEE[];
  position: string[];
  active: boolean;
  viewAll: boolean;
  billingAgent: boolean;
};

export type ConsultantOption = {
  value: string;
  label: string;
};

export const emptyEmployee: IEmployee = {
  _id: "",
  name: "",
  email: "",
  companyId: "",
  companyIds: [],
  type: [],
  position: [],
  active: false,
  viewAll: false,
  billingAgent: false,
};

export enum TYPE_EMPLOYEE {
  MANAGER = "Gerente",
  MECANICO = "Mecânico",
  OPERATOR = "Operador",
  CONSULTANT = "Consultor",
  FINANCIAL = "Financeiro",
  COMMERCIAL_LEADER = "Líder Comercial",
  MANAGER_NFE = "Gerente NFE",
  MAINTENANCE_SCHEDULER = "Agendador de Manutenção",
  MARKETING = "Marketing",
  PURCHASE_ORDER = "Compras",
  STOKIST = "Estoque",
  PREPARER = "Preparador",
}

export const getTypeEmployeeOptions = () => {
  return Object.entries(TYPE_EMPLOYEE).map(([,value]) => ({
    value: value,
    label: value
  }));
};
